<div class="col-sm-9 col-md-8">
  <div class="card pl-3 pr-3 pt-3 pb-3">
    <form
      [formGroup]="memberDetailsForm"
      autocomplete="off"
      class="col-sm-12 col-md-8"
      role="form"
      aria-label="registration form"
    >
      <div class="form-group">
        <label
          ><span aria-hidden="true" class="form-field-required-marker"> *</span>
          {{ 'ACCOUNT.MY_ACCOUNT.FIRST_NAME_LBL' | translate }}</label
        >
        <input
          type="text"
          class="form-control"
          formControlName="first_name"
          role="textbox"
          aria-label="first name input field"
        />
        <div
          *ngIf="submitted && form.first_name.errors"
          class="invalid-feedback"
        >
          <div *ngIf="form.first_name.errors.required" role="alert">
            {{ 'ACCOUNT.MY_ACCOUNT.FIRST_NAME_REQUIRED' | translate }}
          </div>
        </div>
      </div>

      <div class="form-group">
        <label
          ><span aria-hidden="true" class="form-field-required-marker"> *</span>
          {{ 'ACCOUNT.MY_ACCOUNT.LAST_NAME_LBL' | translate }}</label
        >
        <input
          type="text"
          class="form-control"
          formControlName="last_name"
          role="textbox"
          aria-label="last name input field"
        />
        <div
          *ngIf="submitted && form.last_name.errors"
          class="invalid-feedback"
        >
          <div *ngIf="form.last_name.errors.required" role="alert">
            {{ 'ACCOUNT.MY_ACCOUNT.LAST_NAME_REQUIRED' | translate }}
          </div>
        </div>
      </div>

      <div class="form-group">
        <label
          ><span aria-hidden="true" class="form-field-required-marker"> *</span>
          {{ 'ACCOUNT.MY_ACCOUNT.CONTACT_NUMBER_LBL' | translate }}</label
        >
        <input
          type="search"
          class="form-control"
          formControlName="mobile"
          role="textbox"
          aria-label="Mobile number input field"
          (keypress)="keyPressNumberField($event)"
          maxlength="11"
        />
        <div *ngIf="submitted && form.mobile.errors" class="invalid-feedback">
          <div *ngIf="form.mobile.errors.required" role="alert">
            Mobile number is required
          </div>
        </div>
        <div *ngIf="submitted && form.mobile.errors" class="invalid-feedback">
          <div *ngIf="form.mobile.errors.minlength" role="alert">
            Please enter a vaild contact number
          </div>
        </div>
      </div>

      <div class="form-group">
        <label>{{ 'ACCOUNT.MY_ACCOUNT.ADDRESS_LBL' | translate }}</label>
        <input
          type="text"
          class="form-control"
          formControlName="address1"
          role="textbox"
          aria-label="address 1 input field"
        />
      </div>

      <div class="form-group">
        <label>{{ 'ACCOUNT.MY_ACCOUNT.ADDRESS_2_LBL' | translate }}</label>
        <input
          type="text"
          class="form-control"
          formControlName="address2"
          role="textbox"
          aria-label="address 2 input field"
        />
      </div>

      <div class="form-group">
        <label>{{ 'ACCOUNT.MY_ACCOUNT.TOWN_LBL' | translate }}</label>
        <input
          type="text"
          class="form-control"
          formControlName="address4"
          role="textbox"
          aria-label="Address 4 input field"
        />
      </div>

      <div class="form-group">
        <label>{{ 'ACCOUNT.MY_ACCOUNT.COUNRTY_LBL' | translate }}</label>
        <input
          type="text"
          class="form-control"
          formControlName="country"
          role="textbox"
          aria-label="Country input field"
        />
      </div>

      <div class="form-group">
        <label>{{ 'ACCOUNT.MY_ACCOUNT.POSTCODE_LBL' | translate }}</label>
        <input
          type="text"
          class="form-control"
          formControlName="postcode"
          role="textbox"
          aria-label="postcode input field"
        />
      </div>

      <div class="form-group">
        <label
          ><span aria-hidden="true" class="form-field-required-marker"> *</span>
          {{ 'ACCOUNT.MY_ACCOUNT.EMAIL_LBL' | translate }}</label
        >
        <input
          type="text"
          class="form-control"
          formControlName="email"
          role="textbox"
          aria-label="email input field"
        />
      </div>

      <h2>{{ 'FORM.REGISTER.ADDITIONAL_HEADER' | translate }}</h2>
      <hr />
      <!-- Customer questions -->
      <div *ngFor="let question of customerQuestions">
        <div
          class="form-group"
          *ngIf="question.visible && question.detail_type == 'text_field'"
        >
          <label
            ><span
              *ngIf="question.required"
              aria-hidden="true"
              class="form-field-required-marker"
            >
              *</span
            >
            {{ question.name }}</label
          >
          <input
            type="text"
            class="form-control"
            formControlName="{{ question.reference }}"
            role="textbox"
            attr.aria-label="{{ question.name }} input field"
          />
          <div
            *ngIf="submitted && form[question.reference].errors"
            class="invalid-feedback"
          >
            <div *ngIf="form[question.reference].errors.required" role="alert">
              {{ question.name }}
              {{ 'ACCOUNT.MY_ACCOUNT.IS_REQUIRED' | translate }}
            </div>
          </div>
        </div>

        <div
          class="form-group"
          *ngIf="question.visible && question.detail_type == 'text_area'"
        >
          <label
            ><span
              *ngIf="question.required"
              aria-hidden="true"
              class="form-field-required-marker"
            >
              *</span
            >
            {{ question.name }}</label
          >
          <textarea
            class="form-control"
            formControlName="{{ question.reference }}"
            attr.aria-label="{{ question.name }} text area field"
          ></textarea>
          <div
            *ngIf="submitted && form[question.reference].errors"
            class="invalid-feedback"
          >
            <div *ngIf="form[question.reference].errors.required" role="alert">
              {{ question.name }}
              {{ 'ACCOUNT.MY_ACCOUNT.IS_REQUIRED' | translate }}
            </div>
          </div>
        </div>

        <div
          class="form-group"
          *ngIf="question.visible && question.detail_type == 'number'"
        >
          <label
            ><span
              *ngIf="question.required"
              aria-hidden="true"
              class="form-field-required-marker"
            >
              *</span
            >
            {{ question.name }}</label
          >
          <input
            type="number"
            class="form-control"
            formControlName="{{ question.reference }}"
            attr.aria-label="{{ question.name }} input field"
          />
          <div
            *ngIf="submitted && form[question.reference].errors"
            class="invalid-feedback"
          >
            <div *ngIf="form[question.reference].errors.required" role="alert">
              {{ question.name }}
              {{ 'ACCOUNT.MY_ACCOUNT.IS_REQUIRED' | translate }}
            </div>
          </div>
        </div>

        <div
          *ngIf="
            question.visible &&
            question.detail_type == 'select' &&
            question.id == bookingQuestionsConfig.schoolNameSelectionAccounts
          "
        >
          <label
            ><span
              *ngIf="question.required"
              aria-hidden="true"
              class="form-field-required-marker"
            >
              *</span
            >
            {{ question.name }}</label
          >
          <input
            list="question.reference"
            formControlName="{{ question.reference }}"
            class="form-control selectpicker"
            (change)="onQuestionChange()"
          />
          <datalist id="question.reference">
            <option
              *ngFor="let option of question.options"
              [value]="option.name"
            >
              {{ option.name }}
            </option>
          </datalist>
          <div
            *ngIf="submitted && form[question.reference].errors"
            class="invalid-feedback"
          >
            <div *ngIf="form[question.reference].errors.required" role="alert">
              {{ question.name }}
              {{ 'ACCOUNT.MY_ACCOUNT.IS_REQUIRED' | translate }}
            </div>
            <div
              *ngIf="form[question.reference].errors.selectedSchoolErr"
              role="alert"
            >
              {{ form[question.reference].errors.selectedSchoolErr }}
            </div>
          </div>
        </div>

        <div
          class="form-group"
          *ngIf="
            question.visible &&
            question.detail_type == 'select' &&
            question.id != bookingQuestionsConfig.schoolNameSelectionAccounts
          "
        >
          <label
            ><span
              *ngIf="question.required"
              aria-hidden="true"
              class="form-field-required-marker"
            >
              *</span
            >
            {{ question.name }}</label
          >
          <select
            formControlName="{{ question.reference }}"
            class="form-select"
            (change)="onQuestionChange()"
            attr.aria-label="{{ question.name }}"
          >
            <option></option>
            <option
              *ngFor="let option of question.options"
              [value]="option.name"
            >
              {{ option.name }}
            </option>
          </select>
          <div
            *ngIf="submitted && form[question.reference].errors"
            class="invalid-feedback"
          >
            <div *ngIf="form[question.reference].errors.required" role="alert">
              {{ question.name }}
              {{ 'ACCOUNT.MY_ACCOUNT.IS_REQUIRED' | translate }}
            </div>
          </div>
        </div>

        <div
          class="form-group"
          *ngIf="question.visible && question.detail_type == 'date'"
        >
          <label
            ><span
              *ngIf="question.required"
              aria-hidden="true"
              class="form-field-required-marker"
            >
              *</span
            >
            {{ question.name }}</label
          >
          <input
            matInput
            formControlName="{{ question.reference }}"
            [matDatepicker]="picker"
            readonly
          />
          <mat-datepicker-toggle matSuffix [for]="picker">
          </mat-datepicker-toggle>
          <mat-datepicker #picker> </mat-datepicker>
          <div
            *ngIf="submitted && form[question.reference].errors"
            class="invalid-feedback"
          >
            <div *ngIf="form[question.reference].errors.required" role="alert">
              {{ question.name }}
              {{ 'ACCOUNT.MY_ACCOUNT.IS_REQUIRED' | translate }}
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="row mt-4">
    <div class="col-6">
      <button
        type="button"
        class="btn btn-primary col-12 col-sm-10 col-md-6 col-lg-4"
        (click)="cancel()"
        [disabled]="memberDetailsForm.pristine"
      >
        {{ 'COMMON.CANCEL' | translate }}
      </button>
    </div>
    <div class="col-6">
      <button
        class="btn btn-primary float-right col-12 col-sm-10 col-md-6 col-lg-4"
        type="button"
        (click)="onSubmit()"
      >
        {{ 'COMMON.UPDATE' | translate }}
      </button>
    </div>
  </div>
</div>
